import { css } from 'styled-components'

export default css`
  .ant-btn-link {
    color: var(--primary);
  }
`
